import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import faqQuestionApi from '@infrastructure/faq-question-api';
export const getFaqQuestionsByCategoryIdAsync = createAsyncThunk('faqQuestion/getByCategoryId', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.getFaqQuestionsByCategoryId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFaqQuestionByIdAsync = createAsyncThunk('faqQuestion/getById', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.getFaqQuestionById(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createFaqQuestionAsync = createAsyncThunk('faqQuestion/create', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.createFaqQuestion(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFaqQuestionAsync = createAsyncThunk('faqQuestion/update', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.updateFaqQuestion(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFaqQuestionWithCategoryAsync = createAsyncThunk('faqQuestion/updateWithCategory', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.updateFaqQuestionWithCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFaqQuestionAsync = createAsyncThunk('faqQuestion/delete', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.deleteFaqQuestion(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reorderFaqQuestionsAsync = createAsyncThunk('faqQuestion/reorder', async (request, { rejectWithValue }) => {
    try {
        const response = await faqQuestionApi.reorderFaqQuestions(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
